__turbopack_context__.v({
  "Experimente": "_7nHmVW_Experimente",
  "btnBlueExperimente": "_7nHmVW_btnBlueExperimente",
  "corp": "_7nHmVW_corp",
  "dFlex": "_7nHmVW_dFlex",
  "dFlexButtons": "_7nHmVW_dFlexButtons",
  "imgExperimente": "_7nHmVW_imgExperimente",
  "textoExperimente": "_7nHmVW_textoExperimente",
  "title": "_7nHmVW_title",
});
